/**
 * <grid-switcher>
 *
 * Koleksiyon izgarasinin sutun sayisini ziyaretcinin secimine gore degistirir.
 * Masaustunde 2'li / 4'lu, mobilde 1'li / 2'li (Lefties referansi).
 *
 * Durum <html> uzerinde data-grid-desktop / data-grid-mobile olarak tutulur ve
 * localStorage'da 'theme:collection-view:v1' anahtariyla saklanir -- wishlist.js
 * icindeki 'theme:<ozellik>:v1' kuralinin aynisi.
 *
 * Neden <html>: facets.js:95 her filtre/siralama degisiminde
 * #ProductGridContainer'in innerHTML'ini sunucudan gelenle bastan yaziyor ve
 * #product-grid'in data-cols degeri statik tema ayarina geri donuyor. <html>
 * hicbir yeniden render yolunun icinde degil; ustelik CSS kartlari degil izgara
 * kapsayicisini hedefledigi icin dynamic-load-more.js'in ekledigi kartlar da
 * hicbir yeniden baglama olmadan dogru duzende geliyor.
 *
 * Ilk boyamada dogru sutun sayisi icin ayni degerleri yazan kisa bir satir ici
 * script sections/main-collection.liquid ve sections/main-search.liquid icinde
 * izgara markup'indan once calisiyor.
 */

const GRID_VIEW_STORAGE_KEY = 'theme:collection-view:v1';

class GridSwitcher extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialised === 'true') return;
    this.dataset.initialised = 'true';

    this.onClick = this.onClick.bind(this);
    this.addEventListener('click', this.onClick);
    this.syncPressedState();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  onClick(event) {
    const button = event.target.closest('[data-grid-scope]');
    if (!button || !this.contains(button)) return;

    const scope = button.dataset.gridScope === 'desktop' ? 'gridDesktop' : 'gridMobile';
    document.documentElement.dataset[scope] = button.dataset.gridValue;

    GridSwitcher.persist();

    // Sayfada birden fazla switcher olabilir (ust bar + arama sayfasi); hepsini esitle.
    document.querySelectorAll('grid-switcher').forEach((element) => element.syncPressedState());
  }

  syncPressedState() {
    const root = document.documentElement.dataset;

    this.querySelectorAll('[data-grid-scope]').forEach((button) => {
      const current = button.dataset.gridScope === 'desktop' ? root.gridDesktop : root.gridMobile;
      button.setAttribute('aria-pressed', String(current === button.dataset.gridValue));
    });
  }

  static persist() {
    // Gizli sekmede veya depolama doluyken sessizce vazgec -- secim yine de
    // bu sayfa icin gecerli kalir, sadece kalici olmaz.
    try {
      const root = document.documentElement.dataset;
      localStorage.setItem(
        GRID_VIEW_STORAGE_KEY,
        JSON.stringify({ desktop: root.gridDesktop, mobile: root.gridMobile })
      );
    } catch (error) {
      /* yok say */
    }
  }
}

if (!customElements.get('grid-switcher')) {
  customElements.define('grid-switcher', GridSwitcher);
}
